<template>
  <keep-alive :include="['AdminHeader']">
    <router-view :key="$route.fullPath" />
  </keep-alive>
</template>

<script>
const initIMP = () => {
  const IMP = window.IMP
  IMP.init('imp22073745')
}

export default {
  name: 'App',
  created () {
    initIMP()
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue